import style from "./semilleros.module.css";
import foto1 from "../../assets/popular/1.png";
import foto2 from "../../assets/popular/2.png";
import foto3 from "../../assets/popular/3.png";
import foto4 from "../../assets/popular/4.png";
import foto5 from "../../assets/popular/5.png";
import foto6 from "../../assets/popular/6.png";
import foto7 from "../../assets/popular/7.png";
import Helmets from "../../widgets/Helmet";
import WhatsappButton from "../../components/whatsappbutton";
import React, { Suspense, lazy } from "react";
const InstagramEmbed = lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.InstagramEmbed,
  }))
);
const TwitterEmbed = lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.TwitterEmbed,
  }))
);

const Semilleros: React.FC = () => {
  return (
    <>
      <Helmets />
      <main className={style.Master}>
        <WhatsappButton />
        <section className={style.Fotos}>
          <div className={style.FotoMedios}>
            <img
              className={style.FotoImgMedios}
              src={foto1}
              alt="FotoResumen"
              draggable={false}
            />
          </div>
          <div className={style.FotoMedios}>
            <img
              className={style.FotoImgMedios}
              src={foto2}
              alt="FotoResumen"
              draggable={false}
            />
          </div>
        </section>
        <section className={style.Fotos}>
          <div className={style.FotoMedios}>
            <img
              className={style.FotoImgMedios}
              src={foto3}
              alt="FotoResumen"
              draggable={false}
            />
          </div>
          <div className={style.FotoMedios}>
            <img
              className={style.FotoImgMedios}
              src={foto4}
              alt="FotoResumen"
              draggable={false}
            />
          </div>
        </section>
        <section className={style.Fotos}>
          <div className={style.FotoMedios}>
            <img
              className={style.FotoImgMedios}
              src={foto5}
              alt="FotoResumen"
              draggable={false}
            />
          </div>
          <div className={style.FotoMedios}>
            <img
              className={style.FotoImgMedios}
              src={foto6}
              alt="FotoResumen"
              draggable={false}
            />
          </div>
        </section>
        <section className={style.Fotos}>
          <div className={style.FotoMedios}>
            <img
              className={style.FotoImgMedios}
              src={foto7}
              alt="FotoResumen"
              draggable={false}
            />
          </div>
        </section>
          <section className={style.Fotos}>
          <Suspense
            fallback={<div className="loading-placeholder">Loading...</div>}
          >
            <InstagramEmbed
              url="https://www.instagram.com/reel/DJjRQHkteBG/?utm_source=ig_web_button_share_sheet&igsh=MzRlODBiNWFlZA=="
              width={328}
            />
          </Suspense>
          <Suspense
            fallback={<div className="loading-placeholder">Loading...</div>}
          >
            <InstagramEmbed
              url="https://www.instagram.com/p/DJdGvG6tZVB/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
              width={328}
            />
          </Suspense>
          <Suspense
            fallback={<div className="loading-placeholder">Loading...</div>}
          >
            <InstagramEmbed
              url="https://www.instagram.com/reel/DJefJsrtdsX/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
              width={328}
            />
          </Suspense>          
        </section>
        <section className={style.Fotos}>
          <Suspense
            fallback={<div className="loading-placeholder">Loading...</div>}
          >
            <InstagramEmbed
              url="https://www.instagram.com/reel/DJW6RIvtP2f/?utm_source=ig_web_copy_link"
              width={328}
            />
          </Suspense>
          <Suspense
            fallback={<div className="loading-placeholder">Loading...</div>}
          >
            <InstagramEmbed
              url="https://www.instagram.com/reel/DJZoe11tJuA/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              width={328}
            />
          </Suspense>
          <Suspense
            fallback={<div className="loading-placeholder">Loading...</div>}
          >
            <TwitterEmbed
              url="https://twitter.com/rodrisalazarco/status/1918014399324827675"
              width={328}
            />
          </Suspense>
        </section>      
      </main>
    </>
  );
};

export default Semilleros;
